import { useState } from "react"
import { useFormContext } from "react-hook-form"

import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'

import { Wrapper } from "./styled"
import { createSvgIcon } from "@mui/material"
import dayjs, { Dayjs } from "dayjs"
import { COLORS } from "@utils/colors"

const DatePickerVia = () => {
  const [open, setOpen] = useState(false)
  const { watch, setValue, setError, clearErrors, formState: { errors } } = useFormContext()

  const CalendarIcon = createSvgIcon(
    <svg xmlns="http://www.w3.org/2000/svg" width="17" height="19" viewBox="0 0 17 19" fill="black">
      <path d="M1.55847 6.575H1.50847V6.625V14.5312C1.50847 15.1154 1.72629 15.6762 2.11491 16.0902C2.50362 16.5042 3.03153 16.7375 3.58271 16.7375H13.0291C13.5803 16.7375 14.1082 16.5042 14.4969 16.0902C14.8856 15.6762 15.1034 15.1154 15.1034 14.5312V6.625V6.575H15.0534H1.55847ZM15.0534 5.2375H15.1034V5.1875V4.46875C15.1034 3.8846 14.8856 3.32379 14.4969 2.90983C14.1082 2.49576 13.5803 2.2625 13.0291 2.2625H3.58271C3.03153 2.2625 2.50362 2.49576 2.11491 2.90983C1.72629 3.32379 1.50847 3.8846 1.50847 4.46875V5.1875V5.2375H1.55847H15.0534ZM5.26992 10.5838C5.08959 10.7759 4.8457 10.8832 4.59213 10.8832C4.33855 10.8832 4.09467 10.7759 3.91434 10.5838C3.73391 10.3916 3.63203 10.1303 3.63203 9.85722C3.63203 9.58413 3.73391 9.32282 3.91434 9.13062C4.09467 8.93852 4.33855 8.83125 4.59213 8.83125C4.8457 8.83125 5.08959 8.93852 5.26992 9.13062C5.45035 9.32282 5.55222 9.58413 5.55222 9.85722C5.55222 10.1303 5.45035 10.3916 5.26992 10.5838ZM5.5529 13.4517C5.5529 13.7248 5.45102 13.9861 5.27059 14.1783C5.09026 14.3704 4.84638 14.4777 4.5928 14.4777C4.33923 14.4777 4.09534 14.3704 3.91501 14.1783C3.73458 13.9861 3.63271 13.7248 3.63271 13.4517C3.63271 13.1786 3.73458 12.9173 3.91501 12.7251C4.09534 12.533 4.33923 12.4257 4.5928 12.4257C4.84638 12.4257 5.09026 12.533 5.27059 12.7251C5.45102 12.9173 5.5529 13.1786 5.5529 13.4517ZM8.98324 10.5826C8.80303 10.7746 8.55932 10.8818 8.30592 10.8818C8.05217 10.8818 7.80834 10.7758 7.62813 10.5838C7.4477 10.3916 7.34583 10.1303 7.34583 9.85722C7.34583 9.58413 7.4477 9.32282 7.62813 9.13062C7.80847 8.93852 8.05235 8.83125 8.30592 8.83125C8.55932 8.83125 8.80303 8.93845 8.98324 9.13041C9.16354 9.32247 9.26534 9.5836 9.26534 9.8565C9.26534 10.1294 9.16354 10.3905 8.98324 10.5826ZM9.26669 13.4503C9.26669 13.7233 9.16482 13.9847 8.98439 14.1769C8.80406 14.3689 8.56017 14.4762 8.3066 14.4762C8.05302 14.4762 7.80914 14.3689 7.62881 14.1769C7.44838 13.9847 7.3465 13.7233 7.3465 13.4503C7.3465 13.1772 7.44838 12.9158 7.62881 12.7236C7.80914 12.5316 8.05302 12.4243 8.3066 12.4243C8.56017 12.4243 8.80406 12.5316 8.98439 12.7236C9.16482 12.9158 9.26669 13.1772 9.26669 13.4503ZM12.6935 10.5824C12.5131 10.7745 12.2692 10.8818 12.0157 10.8818C11.7621 10.8818 11.5182 10.7745 11.3379 10.5824C11.1574 10.3902 11.0556 10.1289 11.0556 9.85578C11.0556 9.5827 11.1574 9.32138 11.3379 9.12918C11.5182 8.93709 11.7621 8.82981 12.0157 8.82981C12.2692 8.82981 12.5131 8.93709 12.6935 9.12918C12.8739 9.32138 12.9758 9.5827 12.9758 9.85578C12.9758 10.1289 12.8739 10.3902 12.6935 10.5824ZM15.3783 1.96181C16.002 2.62618 16.3529 3.52791 16.3529 4.46875V14.5312C16.3529 15.4721 16.002 16.3738 15.3783 17.0382C14.7547 17.7025 13.9096 18.075 13.0291 18.075H3.58271C2.70226 18.075 1.85718 17.7025 1.23358 17.0382C0.60988 16.3738 0.258984 15.4721 0.258984 14.5312V4.46875C0.258984 3.52791 0.60988 2.62618 1.23358 1.96181C1.85718 1.29754 2.70226 0.925 3.58271 0.925H13.0291C13.9096 0.925 14.7547 1.29754 15.3783 1.96181Z" fill={COLORS.grey[50]} stroke="white" strokeWidth="0.1" />
    </svg>
    , 'calendar')

  const date = watch('date');
  let value = 'Pickup Date';

  if (date) {
    value = date.format('MM/DD/YYYY, ddd')
  }

  return (
    <Wrapper error={errors['date']?.message as string || ''}>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DatePicker
          open={open}
          minDate={dayjs()}
          value={watch('date')}
          onOpen={() => setOpen(true)}
          onClose={() => setOpen(false)}
          format="MM/DD/YYYY, ddd"
          slotProps={{
            textField: {
              InputProps: {
                value: value,
                endAdornment: <CalendarIcon onClick={() => {
                  setOpen(true)
                }} />,
                onClick: () => {
                  setOpen(true)
                },
                placeholder: 'Pickup Date',
              }
            },
          }}
          onChange={(date: Dayjs | null) => {
            if (!date?.isValid() || date.startOf('day')?.isBefore(dayjs().startOf('day'))) {
              setError('date', { message: 'Invalid Date' })
              setValue('date', null)
              return
            }

            clearErrors('date')
            setValue('date', date)
          }}
          showDaysOutsideCurrentMonth
          dayOfWeekFormatter={(day) => {
            switch (day) {
              case 'Mo':
                return 'MON'
              case 'Tu':
                return 'TUE'
              case 'We':
                return 'WED'
              case 'Th':
                return 'THU'
              case 'Fr':
                return 'FRI'
              case 'Sa':
                return 'SAT'
              case 'Su':
                return 'SUN';
              default:
                return 'SUN'
            }
          }}
        />
      </LocalizationProvider>
    </Wrapper>
  )
}

export default DatePickerVia